import { TFunction } from 'i18next'

export enum MainTab {
  TRAININGS,
  PROGRAMS,
  ORGANIZATIONS,
  ABOUT,
  RESOURCES,
  SEARCH,
}

export function getMainTabs(t: TFunction) {
  return [
    { name: t('trainings'), key: MainTab.TRAININGS },
    { name: t('programs'), key: MainTab.PROGRAMS },
    { name: t('forOrganizations'), key: MainTab.ORGANIZATIONS },
    { name: t('aboutUs'), key: MainTab.ABOUT },
    { name: t('resources'), key: MainTab.RESOURCES },
  ]
}
